/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CommentRectXIcon20Solid = forwardRef('CommentRectXIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3h-4.857l-3.53 2.745A1 1 0 0 1 5 16.955V15a3 3 0 0 1-3-3V5Zm11.094 1.594a.875.875 0 0 0-1.238-1.238L10 7.212 8.144 5.356a.875.875 0 1 0-1.238 1.238L8.763 8.45l-1.857 1.856a.875.875 0 1 0 1.238 1.237L10 9.687l1.856 1.856a.875.875 0 1 0 1.238-1.237L11.237 8.45l1.857-1.856Z" })));
});
